package fr.frux.feature.treeadd.wizard

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/** Contrat de fabrique du [TreeWizardViewModel], honoré par le composition root (#43). */
fun interface TreeWizardViewModelFactory {
    fun create(start: TreeWizardStart): TreeWizardViewModel
}

/** Fabrique installée par le composition root ; sans défaut, pour que l'oubli de câblage crie. */
val LocalTreeWizardViewModelFactory =
    staticCompositionLocalOf<TreeWizardViewModelFactory> {
        error("TreeWizardViewModelFactory absente : le composition root doit l'installer (#43)")
    }

/** Fabrique le ViewModel de l'assistant, porté par l'entrée de navigation. */
@Composable
fun rememberTreeWizardViewModel(start: TreeWizardStart): TreeWizardViewModel {
    val factory = LocalTreeWizardViewModelFactory.current
    return viewModel { factory.create(start) }
}
